export const environment = {
    production: true,
    urlBack: 'https://gilcomes.api.atalaya.ai/api/v1/',
    urlBackOffice: 'https://gilcomes.atalaya.ai',
    urlFront: 'https://gilcomes.app.atalaya.ai/login',
    client_id: 'VfXRWI4En5s1DF4MTggVhjuA3jPzDEemdgtg5Pni',
    client_secret:
        'FuowOfm1k9aOrCPd8ChRsSNj6GMdnlipo3CrLe4FvaI9HH5VYOkx9pGpUgkn1BLFlx1DwsVj3moCAHc5XAWR6RJE9rn1Am7iX5bSLwmgxPmsNOLXiLNieos4QhsDC3d3',
};
